function get(state) {
    return state.queue;
}

export function isEmpty(state) {
    return get(state).length === 0;
}

export function head(state) {
    return get(state)[0];
}
